import React, { useEffect, useState } from 'react';
import axios from 'axios';
import API_BASE_URL from '../config';

const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

export default function BlockedUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(null);
  const [notice, setNotice] = useState('');
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError('');
    axios.get(`${API_BASE_URL}/blocked_users`, auth())
      .then(({ data }) => { if (active) setUsers(data.blocked_users); })
      .catch(() => { if (active) setError("לא ניתן לטעון את רשימת החסומים. נסו שוב."); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [attempt]);

  const unblock = async (user) => {
    setBusy(user.id);
    setError('');
    setNotice('');
    try {
      await axios.delete(`${API_BASE_URL}/blocked_users/${user.id}`, auth());
      setUsers(previous => previous.filter(item => item.id !== user.id));
      setNotice(`${user.username} — החסימה הוסרה.`);
    } catch {
      setError("לא ניתן להסיר את החסימה. נסו שוב.");
    } finally {
      setBusy(null);
    }
  };

  return <section className="profile-section" aria-labelledby="blocked-users-heading">
    <h3 id="blocked-users-heading">חשבונות חסומים</h3>
    <p>הסרת חסימה מאפשרת התאמות בעתיד. שיחות קודמות נשארות מחוקות.</p>
    {loading && <p role="status">טוענים את רשימת החסומים…</p>}
    {error && <p role="alert">{error} <button type="button" onClick={() => setAttempt(value => value + 1)}>טעינת הרשימה מחדש</button></p>}
    {notice && <p role="status">{notice}</p>}
    {!loading && !error && users.length === 0 && <p>אין חשבונות חסומים.</p>}
    <ul className="blocked-users-list">
      {users.map(user => <li key={user.id}>
        <span>{user.username}</span>
        <button type="button" className="profile-secondary-button" disabled={busy !== null}
          aria-label={`הסרת חסימה עבור ${user.username}`} onClick={() => unblock(user)}>
          {busy === user.id ? 'מסירים חסימה…' : "הסרת חסימה"}
        </button>
      </li>)}
    </ul>
  </section>;
}
